import { Button, Card } from '@/components/generic';
import { useTranslation } from 'react-i18next';

const Delete = () => {
  const { t } = useTranslation();

  return (
    <Card title={t('profile.delete.title')} className='m-0'>
      <form className='flex flex-col gap-8 p-5 pt-0 max-lg:px-3 max-md:gap-4'>
        <Button className='self-start label-red w-full' type='button'>
          {t('profile.delete.button')}
        </Button>
      </form>
    </Card>
  );
};

export default Delete;
